module.exports = __webpack_public_path__ + "static/media/timber01.f5b1502b.jpg";